function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,15h30v10H0v-10ZM5,15c0,3.682,2.985,6.667,6.667,6.667s6.667-2.985,6.667-6.667-2.985-6.667-6.667-6.667-6.667,2.985-6.667,6.667",
    style: {
      fill: "#c8102e"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGl);
export default __webpack_public_path__ + "static/media/GL.2872b934d4c967ca28c98e8e5017b376.svg";
export { ForwardRef as ReactComponent };